// Standalone utility for heading levels - extracted from components/heading.tsx
// to avoid pulling in React components (which may import zui-provider) when used in Node.js environments
export const headingLevels = ['h1', 'h2', 'h3', 'h4'] as const;
export type HeadingLevel = (typeof headingLevels)[number];

export const effectiveHeadingLevel = (level: string): HeadingLevel =>
  headingLevels.includes(level as never) ? (level as HeadingLevel) : 'h4';
